

import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Line } from "react-chartjs-2";
import { chartOptions } from "../../helpers/utils";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader"

export default function CodeIssuedChart({signupMethod, numberLastDays}) {
    const [datasets, setDatasets] = useState()
    const [labels, setLabels] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { token } = useToken()
    const { timeZone } = useTimeZone()

    const buildCustomChart = (labels = [],  _datasets = { 'Amazon': [], 'Vudu': [], 'Fandango': [], 'AMC': [] } ) => {
        return (canvas) => {
            if (!canvas) return
            let ctx = canvas.getContext("2d");
    
            let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
    
            gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
            gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
            gradientStroke.addColorStop(0, "rgba(29,140,248,0)");
            
            var colorArr = ["#2536D3", "#33D325", "#D32525", "#eaff00"]
            var names = ["Amazon", "Vudu", "AMC"]
            var datasets = []
            var _key = ["Amazon", "Vudu", "AMC"]
    
            for (let i = 0; i < 3; i++) {
                datasets.push({
                    label: names[i],
                    fill: false,
                    backgroundColor: gradientStroke,
                    borderColor: colorArr[i],
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: colorArr[i],
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: colorArr[i],
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: _datasets[_key[i]]
                })
            }
    
            return {
                labels: labels,
                datasets: datasets
            }
        }
    };

    useEffect(() => {
        async function initData() {
            console.log('CodeIssuedChart: update data')
            if (parseInt(numberLastDays) === 0) return
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            var params = new URLSearchParams({
                'timezone_offset_minutes': timeZone * -60,
                'number_last_days': numberLastDays
            })

            fetch(process.env.REACT_APP_BASE_URL + "dashboard/code_issued_chart?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    async (result) => {
                        var json = result.json
                        if (result.ok) {
                            setDatasets(json?.data.datasets)
                            setLabels(json?.data.labels)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [setIsLoading, token, numberLastDays, timeZone])

    return (
        <TMHLoader active={isLoading}>

            <Row>
                <Col md="12">
                    <Card className="card-chart">
                        <CardHeader>
                            <Row>
                                <Col className="text-left" sm="6">
                                    <h5>Code Issued { (signupMethod !== "All") && (" - " + signupMethod) }</h5>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="chart-area">
                                {
                                    datasets && <Line
                                        data={buildCustomChart(labels, datasets[signupMethod])}
                                        options={chartOptions(true)} />
                                }
                            </div>

                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}